import { render, staticRenderFns } from "./escalation_status.vue?vue&type=template&id=119c7dc1"
import script from "./escalation_status.vue?vue&type=script&lang=js"
export * from "./escalation_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports